
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { UsuariosTable } from "./UsuariosTable";
import { NovoUsuarioDialog } from "./NovoUsuarioDialog";
import { Users } from "lucide-react";

export function Usuarios() {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Usuários</h2>
          <p className="text-gray-600">Gerencie usuários do sistema</p>
        </div>
        <NovoUsuarioDialog />
      </div>

      <div className="grid grid-cols-1 gap-6">
        <UsuariosTable />
      </div>
    </div>
  );
}
